import {css} from '@mui/material';
import React from 'react';
import {GetStylesFunction} from 'src/js/common/types';

import {DlMuiTypography} from '../../../components';

interface OwnProps {
  label?: string;
}

type Props = OwnProps;

export const HierarchyNodeItemLabel: React.FC<Props> = (props) => {
  const {label = ''} = props;
  const styles = getStyles();

  return (
    <DlMuiTypography
      variant={'hierarchyLabel'}
      inputCss={styles.dlHierarchyNodeItemLabel}
      title={label}
      value={label}
    />
  );
};

HierarchyNodeItemLabel.displayName = 'HierarchyNodeItemLabel';

const getStyles: GetStylesFunction = () => ({
  dlHierarchyNodeItemLabel: css`
    word-break: break-word;
    text-align: start;
    padding-left: 4px;
    color: inherit;
  `,
});
